import {KTCardBody} from '../../../../_metronic/helpers/components/KTCardBody'
import PluginData from '../plugins/PluginsData'
import clsx from 'clsx'
import {useIntl} from 'react-intl'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import {Link, Route, Routes, useLocation} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import SitePricingPlugin from './Components/SitePricing/SitePricingPlugin'
import RewardPlugin from './Components/Reward/RewardPlugin'
import LegalInformationPlugin from './Components/LegalInformation/LegalInformationPlugin'
import GeneralPlugin from './Components/General/GeneralPlugin'
import RazorpayPaymentPlugin from './Components/RazorpayPayment/RazorpayPaymentPlugin'
import PhonePayPlugin from './Components/PhonePay/PhonePayPlugins'
import FolderStructurePlugin from './Components/FolderStructure/folderStrucuturePlugin'
import SmtpPlugin from './Components/Smtp/SmtpPlugin'
import AdsPlugin from './Components/AdsKey/AdsPlugin'
import AdsPlanPlugin from './Components/AdsPlanner/AdsPlanPlugin'
import NotificationPlugin from './Components/Notification/NotificationPlugin'
import BannerPlugin from './Components/Banner/BannerPlugin'
import StoreSettingBannerPlugin from './Components/StoreSettingBanner/StoreSettingBannerPlugin'
import CategoriesPlugin from './Components/CategoriesAndSubCategories/CategoriesPlugin'
import CashFreePaymentPlugin from './Components/CashFree/CashFreePlugin'
import UserSettingBannerPlugin from './Components/UserSettingBanner/UserSettingBannerPlugin'
import UserFaqsPlugin from './Components/UserFaqs/UserFaqsPlugin'
import StoreFaqsPlugin from './Components/StoreFaqs/StoreFaqsPlugin'
import StoragePlugin from './Components/Storage/StoragePlugins'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Plugins',
    path: 'plugins',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const Plugins = () => {
  const intl = useIntl()
  const location = useLocation()
  const pluginList = PluginData

  return (
    <>
      <PageTitle breadcrumbs={usersBreadcrumbs}>
        {intl.formatMessage({id: 'MENU.PLUGINS'})}
      </PageTitle>
      {location.pathname === '/plugins' && (
        <KTCardBody className='py-4 card'>
          <div className='table-responsive'>
            <table
              id='kt_table_users'
              className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
            >
              <thead>
                <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
                  <td colSpan={4}>{intl.formatMessage({id: 'PLUGINS.TABLE.PLUGINNAME'})}</td>
                  <td colSpan={4}>{intl.formatMessage({id: 'PLUGINS.TABLE.DESCRIPTION'})}</td>
                  <td colSpan={2}>{intl.formatMessage({id: 'PLUGINS.TABLE.STATUS'})}</td>
                  <td colSpan={2}>{intl.formatMessage({id: 'PLUGINS.TABLE.ACTIONS'})}</td>
                </tr>
              </thead>
              <tbody className='text-gray-600 '>
                {pluginList.map((plugin) => {
                  return (
                    <tr>
                      <td colSpan={4}>
                        <div className='d-flex align-items-center '>
                          <div className='symbol symbol-50px overflow-visible me-3'>
                            <img
                              src={
                                toAbsoluteUrl(plugin.icon) ||
                                `https://preview.keenthemes.com/metronic8/react/demo1//media/avatars/300-6.jpg`
                              }
                              alt='icon'
                              width='50px'
                              height='50px'
                              loading='lazy'
                            />
                          </div>

                          <div className='flex-grow-1'>
                            <Link
                              to={`/plugins/${plugin.path}`}
                              className='text-gray-800 text-hover-primary fw-bold fs-4'
                            >
                              {plugin.name}
                            </Link>
                            <span className='text-muted fw-semibold d-block fs-6'>
                              {plugin.type}
                            </span>
                          </div>
                        </div>
                      </td>
                      <td colSpan={4}>
                        <div className='text-muted fw-semibold fs-6'>{plugin.description}</div>
                      </td>
                      <td colSpan={2}>
                        <span
                          className={clsx('badge rounded-pill  ', {
                            'text-bg-success text-white': plugin.status === 'Active',
                            'text-bg-danger text-white': plugin.status === 'Disabled',
                          })}
                        >
                          {plugin.status}
                        </span>
                      </td>
                      <td colSpan={2}>
                        <Link to={`/plugins/${plugin.path}`}>
                          <button className='btn btn-sm btn-light' data-kt-menu-dismiss='true'>
                            <i className='fa-solid fa-gear'></i>
                            Setting
                          </button>
                        </Link>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </KTCardBody>
      )}

      <Routes>
        <Route
          path='/category_plugin'
          element={
            <>
              <PageTitle>Category Plugin</PageTitle>
              <CategoriesPlugin />
            </>
          }
        />
        <Route
          path='/site_pricing_plugin'
          element={
            <>
              <PageTitle>Site Pricing</PageTitle>
              <SitePricingPlugin />
            </>
          }
        />
        <Route
          path='/reward_plugin'
          element={
            <>
              <PageTitle>Reward</PageTitle>
              <RewardPlugin />
            </>
          }
        />
        <Route
          path='/general_plugin'
          element={
            <>
              <PageTitle>General</PageTitle>
              <GeneralPlugin />
            </>
          }
        />
        <Route
          path='/legal_information_plugin'
          element={
            <>
              <PageTitle>Legal Information</PageTitle>
              <LegalInformationPlugin />
            </>
          }
        />
        <Route
          path='/razor_pay_payment_plugin'
          element={
            <>
              <PageTitle>Razor Pay Payment Gateways</PageTitle>
              <RazorpayPaymentPlugin />
            </>
          }
        />
        <Route
          path='/cash_free_payment_plugin'
          element={
            <>
              <PageTitle>Cash Free Payment Gateways</PageTitle>
              <CashFreePaymentPlugin />
            </>
          }
        />
        <Route
          path='/phone_pay_payment_plugin'
          element={
            <>
              <PageTitle>Phone Pay Payment Gateways</PageTitle>
              <PhonePayPlugin />
            </>
          }
        />
        <Route
          path='/folder_structure_plugin'
          element={
            <>
              <PageTitle>Folder Structure Setting</PageTitle>
              <FolderStructurePlugin />
            </>
          }
        />
        <Route
          path='/smtp_plugin'
          element={
            <>
              <PageTitle>SMTP Plugin</PageTitle>
              <SmtpPlugin />
            </>
          }
        />
        <Route
          path='/ads_plugin'
          element={
            <>
              <PageTitle>Ads Plugin</PageTitle>
              <AdsPlugin />
            </>
          }
        />
        <Route
          path='/ads_plan_plugin'
          element={
            <>
              <PageTitle>Ads Plan Plugin</PageTitle>
              <AdsPlanPlugin />
            </>
          }
        />
        <Route
          path='/notification_plugin'
          element={
            <>
              <PageTitle>Notification Plugin</PageTitle>
              <NotificationPlugin />
            </>
          }
        />
        {/* <Route
          path='/moderator_level_system'
          element={
            <>
              <PageTitle>Moderator Level System</PageTitle>
              <ModeratorLevelSystemPlugin />
            </>
          }
        /> */}
        <Route
          path='/banner_plugin'
          element={
            <>
              <PageTitle>Banner Plugin</PageTitle>
              <BannerPlugin />
            </>
          }
        />
        <Route
          path='/store_setting_banner_plugin'
          element={
            <>
              <PageTitle>Store Setting Banner Plugin</PageTitle>
              <StoreSettingBannerPlugin />
            </>
          }
        />
        <Route
          path='/user_setting_banner_plugin'
          element={
            <>
              <PageTitle>User Setting Banner Plugin</PageTitle>
              <UserSettingBannerPlugin />
            </>
          }
        />
        <Route
          path='/user_faqs_plugin'
          element={
            <>
              <PageTitle>User FAQS Plugin</PageTitle>
              <UserFaqsPlugin />
            </>
          }
        />
        <Route
          path='/store_faqs_plugin'
          element={
            <>
              <PageTitle>Store FAQS Plugin</PageTitle>
              <StoreFaqsPlugin />
            </>
          }
        />
        <Route
          path='/wasabi_faqs_plugin'
          element={
            <>
              <PageTitle>Storage And Backup Setting Plugin</PageTitle>
              <StoragePlugin />
            </>
          }
        />
      </Routes>
    </>
  )
}

export default Plugins
